import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Export data trimming utilities
export * from "./utils/data-trimmer";

/**
 * Utility function to download a blob as a file
 * @param blob - The blob data to download
 * @param filename - The name of the file to download
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/**
 * Utility function to get file extension from filename
 * @param filename - The filename to extract extension from
 * @returns The file extension (without dot) or empty string if no extension
 */
export function getFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex > 0 ? filename.substring(lastDotIndex + 1).toLowerCase() : '';
}

/**
 * Utility function to format file size in human readable format
 * @param bytes - Size in bytes
 * @returns Formatted size string (e.g., "1.5 MB")
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/**
 * Utility function to format date string to locale string
 * @param dateString - The date string to format
 * @returns Formatted date string or "N/A" if invalid/empty
 */
export function formatDateTime(dateString: string): string {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString();
}
